var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPrintTicket(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "print_ticket",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_348",
    "data-name": "Rect\\xE1ngulo 348",
    width: 20,
    height: 20,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_21",
    "data-name": "Rect\\xE1ngulo 21",
    width: 15.13,
    height: 14.136,
    fill: "#b1cb79",
    stroke: "#707070",
    strokeWidth: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_51",
    "data-name": "Enmascarar grupo 51",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_50",
    "data-name": "Grupo 50",
    transform: "translate(2.353 2.932)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13",
    "data-name": "Grupo 13",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10",
    "data-name": "Trazado 10",
    d: "M12.776,3.706a.913.913,0,0,0-.991-.984H10.445V2.571q0-1.042,0-2.084c0-.355-.133-.487-.491-.487H2.816c-.349,0-.485.134-.485.481q0,1.036,0,2.071v.17H2.194c-.4,0-.8.01-1.2,0a.924.924,0,0,0-.983.756c0,.007-.009.013-.014.02V8.712a1.108,1.108,0,0,0,.27.509.947.947,0,0,0,.68.262H2.331v.161q0,.83,0,1.66c0,.341.137.479.474.479H9.967c.339,0,.477-.137.477-.476q0-.83,0-1.659V9.483h1.341a.915.915,0,0,0,.991-.985q0-2.4,0-4.791M3.113.779H9.664V2.717H3.113ZM9.664,11H3.111V7.191H9.664Zm2.144-2.3H10.445V8.543c0-.557,0-1.114,0-1.672,0-.322-.142-.462-.465-.462H2.793c-.321,0-.461.142-.462.466q0,.836,0,1.672V8.7c-.047,0-.083.007-.12.007H.976c-.168,0-.2-.036-.2-.206q0-2.4,0-4.8c0-.17.035-.205.2-.205H11.8c.163,0,.2.036.2.2Q12,6.1,12,8.507c0,.162-.038.2-.195.2",
    transform: "translate(1.177 1.176)",
    fill: "#b1cb79",
    stroke: "#b1cb79",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11",
    "data-name": "Trazado 11",
    d: "M266.282,122.98a.555.555,0,0,0-.548.548.548.548,0,1,0,.548-.548",
    transform: "translate(-255.048 -117.403)",
    fill: "#b1cb79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12",
    "data-name": "Trazado 12",
    d: "M119,222.618c.582,0,1.164,0,1.746,0s1.155,0,1.733,0a.387.387,0,1,0-.013-.772c-.582,0-1.164,0-1.746,0-.561,0-1.122,0-1.683,0a.4.4,0,0,0-.4.237.381.381,0,0,0,.365.535",
    transform: "translate(-113.182 -212.731)",
    fill: "#b1cb79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13",
    "data-name": "Trazado 13",
    d: "M122.5,264.852c-.578,0-1.155,0-1.733,0h-.736c-.345,0-.69,0-1.035,0a.377.377,0,0,0-.376.372.383.383,0,0,0,.347.389,1.037,1.037,0,0,0,.137.007h3.316a.987.987,0,0,0,.174-.012.359.359,0,0,0,.293-.257.38.38,0,0,0-.387-.5",
    transform: "translate(-113.197 -254.195)",
    fill: "#b1cb79"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrintTicket);
export default __webpack_public_path__ + "static/media/icon_print_ticket.0da4212b0ba224799bbcaea5b7cd086d.svg";
export { ForwardRef as ReactComponent };